import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import ur from "./locales/ur.json";
import arAE from "./locales/ar-AE.json";

export const SUPPORTED_LANGUAGES = [
    { code: "en", label: "English", dir: "ltr" as const },
    { code: "ur", label: "اردو", dir: "rtl" as const },
    { code: "ar-AE", label: "العربية (الإمارات)", dir: "rtl" as const },
] as const;

export const DEFAULT_LANGUAGE = "en";

export const RTL_LANGUAGES = ["ur", "ar-AE"];

export function isRtl(lang: string): boolean {
    return RTL_LANGUAGES.includes(lang);
}

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            ur: { translation: ur },
            "ar-AE": { translation: arAE },
        },
        fallbackLng: DEFAULT_LANGUAGE,
        supportedLngs: ["en", "ur", "ar-AE"],
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
            lookupLocalStorage: "maeiz-rider-lang",
        },
    });

export default i18n;
